var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContractR(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.45845 1.1662H2.62465C2.23784 1.1662 1.86688 1.28913 1.59337 1.50794C1.31986 1.72675 1.1662 2.02352 1.1662 2.33296V11.667C1.1662 11.9765 1.31986 12.2733 1.59337 12.4921C1.86688 12.7109 2.23784 12.8338 2.62465 12.8338H11.3753C11.7622 12.8338 12.1331 12.7109 12.4066 12.4921C12.6801 12.2733 12.8338 11.9765 12.8338 11.667V4.66648M8.45845 1.1662C8.68929 1.1659 8.91792 1.20214 9.13118 1.27283C9.34444 1.34351 9.53811 1.44725 9.70105 1.57807L12.3175 3.67124C12.4815 3.80162 12.6115 3.95671 12.7001 4.12753C12.7887 4.29836 12.8342 4.48153 12.8338 4.66648M8.45845 1.1662V4.0831C8.45845 4.23782 8.53528 4.38621 8.67203 4.49561C8.80879 4.60502 8.99427 4.66648 9.18767 4.66648L12.8338 4.66648M5.54155 5.24986H4.0831M9.9169 7.58338H4.0831M9.9169 9.9169H4.0831",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractR);
export default __webpack_public_path__ + "static/media/ContractR.81e7700cb964aafdaac447f58b033d70.svg";
export { ForwardRef as ReactComponent };